import React from 'react';
import CheckoutFormWrapper from './CheckoutFormWrapper';
import Amc12Features from './Amc12Features';
import Amc8Features from './Amc8Features';
import GreFeatures from './GreFeatures';
import SieFeatures from './SieFeatures';
import Series6Features from './Series6Features';
import Series7Features from './Series7Features';
import Series63Features from './Series63Features';
import Series65Features from './Series65Features';
import Series66Features from './Series66Features';
import UsmleStep1Features from './UsmleStep1Features';
import AuthorCallout from './AuthorCallout';
import DefaultFeatures from './DefaultFeatures';
import { useTrack } from '$lib/tracking';
import styles from './styles.scss';

const FEATURES_MAP = {
  'amc-12': Amc12Features,
  'amc-8': Amc8Features,
  gre: GreFeatures,
  'finra-sie': SieFeatures,
  'finra-series-6': Series6Features,
  'finra-series-7': Series7Features,
  'finra-series-63': Series63Features,
  'finra-series-65': Series65Features,
  'finra-series-66': Series66Features,
  'usmle-step-1': UsmleStep1Features,
};

const TAGLINES = {
  'amc-12': 'Achievable AMC 10/12 is your secret weapon',
};

const ProductUpgrade = (props) => {
  const { currentUser, product } = props;
  const { slug } = product;
  useTrack('Purchase page | Viewed', { productSlug: slug });

  const Features = FEATURES_MAP[slug] || DefaultFeatures;

  const tagline = TAGLINES[slug] || `${product.shortName} has everything you need}`;

  return (
    <div>
      <div className={styles.upgradeText}>
        <p>Ready to get serious about studying for the {product.name}?</p>
        <AuthorCallout slug={slug} />
        <div className={styles.layout}>
          <div className={styles.title}>
            <span className={styles.underline}>{tagline}</span>
          </div>
          <Features />
          <p>
            Questions? Call or text us at{' '}
            <a href="tel:415-831-7733">
              <i className="fad fa-phone" />
              415-831-7733
            </a>
            .
          </p>
        </div>
      </div>
      <CheckoutFormWrapper
        className={styles.checkoutForm}
        currentUser={currentUser}
        product={product}
      />
    </div>
  );
};

export default ProductUpgrade;
